var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4.4934C3.604 4.4934 4.5 3.54069 4.5 2.36682C4.5 1.19294 3.604 0.240234 2.5 0.240234C1.396 0.240234 0.5 1.19294 0.5 2.36682C0.5 3.54069 1.396 4.4934 2.5 4.4934ZM2.5 7.68327C1.396 7.68327 0.5 8.63598 0.5 9.80985C0.5 10.9837 1.396 11.9364 2.5 11.9364C3.604 11.9364 4.5 10.9837 4.5 9.80985C4.5 8.63598 3.604 7.68327 2.5 7.68327ZM0.5 17.2529C0.5 16.079 1.396 15.1263 2.5 15.1263C3.604 15.1263 4.5 16.079 4.5 17.2529C4.5 18.4268 3.604 19.3795 2.5 19.3795C1.396 19.3795 0.5 18.4268 0.5 17.2529Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.a97ef8dd8cc4698953744ed55da3bc9c.svg";
export { ForwardRef as ReactComponent };